import { Injectable } from "@angular/core";
import { QueryStringSerializationService } from "apps-module/app/shared-library/services/environment/query-string-serialization.service";
import { nameof } from "apps-module/app/shared-library/utils/common.utils";
import { NumericUtils } from "apps-module/app/shared-library/utils/numeric.utils";

import { FormSearchParametersModel } from "../models/form-search-parameters.model";
import { QuerySearchParametersModel } from "../models/query-search-parameters.model";
import { SearchConfigurationModel } from "../models/search-configuration.model";

@Injectable()
export class FormSearchParametersService {

    public constructor(
        private _serializationService: QueryStringSerializationService
    ) {
    }

    public create(queryString: string, configuration: SearchConfigurationModel): FormSearchParametersModel {
        const rawValues = this._serializationService.deserialize(queryString);

        const formParameters = {
            pageId: configuration.pageId,
            pageNumber: NumericUtils.parse(rawValues[nameof<QuerySearchParametersModel>("pageNumber")] as string, 1),
            searchText: rawValues[nameof<QuerySearchParametersModel>("searchText")] as string || "",
            location: rawValues[nameof<QuerySearchParametersModel>("location")] as string || "",
            minCapacity: NumericUtils.parse(rawValues[nameof<QuerySearchParametersModel>("minCapacity")] as string, configuration.minCapacity),
            maxCapacity: NumericUtils.parse(rawValues[nameof<QuerySearchParametersModel>("maxCapacity")] as string, configuration.maxCapacity),
            facilities: rawValues[nameof<QuerySearchParametersModel>("facilities")] as Array<string> || []
        } as FormSearchParametersModel;

        return formParameters;
    }
}
